import { render } from "./MultiDefaultValueSelectDialog.vue?vue&type=template&id=195f3d66"
import script from "./MultiDefaultValueSelectDialog.vue?vue&type=script&lang=js"
export * from "./MultiDefaultValueSelectDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__